import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useLayout } from "@/contexts/LayoutContext";
import { useQuickTask } from "@/contexts/QuickTaskContext";
import { buildAddTaskUrl } from "./NewTaskButton";
import { headerIconButtonClass } from "./headerButton";
import { HeaderTip } from "./HeaderTip";

export const QuickTaskButton = () => {
  const { data } = useLayout();
  const { openQuickTask } = useQuickTask();
  const icon = <FontAwesomeIcon icon={faCircleCheck} size="lg" />;

  return (
    <HeaderTip label="Create Activity">
      {data.newTaskDefaultFull === true ? (
        <a
          href={buildAddTaskUrl()}
          aria-label="Create Activity"
          data-testid="header-quick-task-button"
          className={headerIconButtonClass}
        >
          {icon}
        </a>
      ) : (
        <button
          type="button"
          onClick={openQuickTask}
          aria-label="Create Activity"
          data-testid="header-quick-task-button"
          className={headerIconButtonClass}
        >
          {icon}
        </button>
      )}
    </HeaderTip>
  );
};
